import { render, staticRenderFns } from "./dy_award.vue?vue&type=template&id=1881042a&scoped=true"
import script from "./dy_award.vue?vue&type=script&lang=ts"
export * from "./dy_award.vue?vue&type=script&lang=ts"
import style0 from "./dy_award.vue?vue&type=style&index=0&id=1881042a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1881042a",
  null
  
)

export default component.exports